<template>
  <div>
    <div class="meetingDetail">
      <img :src="detailData.detailImg" alt="校友会图片" class="Img" />
      <div class="join" @click="join">校友加入</div>
      <div class="detailTishi">
        一个人最多可以加入三个地区分会和一个院系分会
      </div>
      <div class="detailTitle">{{ detailData.title }}</div>
      <div class="detailflex">
        <!-- <div class="detailflexRow" v-if="detailData.establishTime != '' && detailData.establishTime !=null">
          <div>成立时间：</div>
          <div>{{ detailData.establishTime }}</div>
        </div> -->
        <!-- <div class="detailflexRow" v-if="detailData.mastorName != '' && detailData.mastorName !=null">
          <div>会&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;长：</div>
          <div>{{ detailData.mastorName }}</div>
        </div> -->
        <!-- <div class="detailflexRow" v-if="detailData.secretaryName != '' && detailData.secretaryName !=null">
          <div>秘&nbsp;&nbsp;书&nbsp;&nbsp;长：</div>
          <div>{{ detailData.secretaryName }}</div>
        </div> -->
        <!-- TODO -->
        <!-- <div
          class="detailflexRow"
          v-if="detailData.contacts != '' && detailData.contacts != null"
        >
          <div>联&nbsp;&nbsp;系&nbsp;&nbsp;人：</div>
          <div>{{ detailData.contacts }}</div>
          <img
            src="../../assets/image/btn_dianhua_nor.png"
            alt="电话"
            class="contactsImg"
            @click="() => onHeaderDetailActionClick({ action: 'tel' })"
          />
          <img
            @click="() => onHeaderDetailActionClick({ action: 'qrcode' })"
            src="../../assets/image/btn_erweima_nor.png"
            alt="二维码"
            class="contactsImg"
          />
        </div> -->
        <div
          class="detailflexRow"
          v-for="(item, index) in lianxiren"
          :key="index"
        >
          <div
            v-if=" item.name != null"
            class="detailflexRow"
          >
            <div>联&nbsp;&nbsp;系&nbsp;&nbsp;人：</div>
            <div>{{ item.name }}</div>
            <!-- <img
            src="../../assets/image/btn_dianhua_nor.png"
            alt="电话"
            class="contactsImg"
            @click="() => onHeaderDetailActionClick({ action:'tel',tel:item.tel})"
          /> -->
            <div
              class="contactsImg"
              @click="
                () =>
                  onHeaderDetailActionClick({ action: 'tel', tel: item.tel })
              "
            >
              <img
                src="../../assets/image/btn_dianhua_nor.png"
                alt="电话"
                class="telIcon"
              />
              <!-- </a> -->
            </div>
            <img
              @click="() => onHeaderDetailActionClick({ action: 'qrcode' })"
              src="../../assets/image/btn_erweima_nor.png"
              alt="二维码"
              class="contactsImg"
            />
          </div>
        </div>
        <!-- TODO -->
        <!-- <div class="detailflexRow" v-if="detailData.email != '' && detailData.email !=null">
          <div>邮&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp箱：</div>
          <div>{{ detailData.email }}</div>
        </div> -->
      </div>
      <div
        class="fg"
        v-if="
          detailData.member != '' ||
          (detailData.content != '' && detailData.content != null)
        "
      ></div>
      <div
        class="detailflex clearfix"
        style="margin-top: 10px"
        v-if="detailData.member != ''"
      >
        <div class="detailflexRow">
          <div class="FirstLevelTitle">
            <div>校友成员</div>
            <div @click="alumniMembers(detailData.id)">更多</div>
          </div>
        </div>
        <!-- 滑动列表 -->
        <div class="activeDetailsDiv">
          <div
            class="clearfix"
            style="width: 400vw; display: flex; flex-direction: row"
          >
            <div
              class="activeDetails-fh clearfix"
              v-for="item in detailData.member"
              :key="item.id"
            >
              <AlumniInfoCard
                :info="item"
                @go="gotoAlumnusDetail"
              ></AlumniInfoCard>
            </div>
          </div>
        </div>
      </div>

      <div
        class="detailflex"
        style="margin-top: 10px"
        v-if="detailData.content != '' && detailData.content != null"
      >
        <div class="detailflexRow">
          <div class="FirstLevelTitle">
            <div>{{ detailData.title }}介绍</div>
          </div>
        </div>
      </div>
      <div class="jieshaobox" v-if="fengeList != ''">
        <div v-for="(segment, index) in fengeList" :key="index">
          {{ segment }}
        </div>
      </div>
    </div>

    <van-action-sheet
      v-model="isDialActive"
      :actions="[{ name: `联系人电话：${phone}` }]"
      cancel-text="取消"
      close-on-click-action
      @select="onDialogActionSelect"
    />
    <van-dialog
      v-model="isQrCodeActive"
      :showConfirmButton="false"
      closeOnClickOverlay
      closeOnPopstate
    >
      <van-image class="active-detail__qrcode-image" :src="detailData.qrCode" />
      <van-button
        class="active-detail__qrcode-image-btn"
        type="info"
        round
        @click="onSaveQrCodeBtnClick"
      >
        保存二维码
      </van-button>
    </van-dialog>
  </div>
</template>
<script>
import download from "@/utils/download";
import defaultAvatar from "@/assets/image/defaultAvatar.png";
import btnXuexiao from "@/assets/image/btn_xuexiao_nor.png";
import btnDianhua from "@/assets/image/btn_dianhua_nor.png";
import btnRenzheng from "@/assets/image/btn_renzheng_nor.png";
import btnNv from "@/assets/image/btn_nv_nor.png";
import btnNan from "@/assets/image/btn_nan_nor.png";
import Base64 from "@/utils/base64";
import AlumniInfoCard from "./components/AlumniMembers/alumniComponents.vue";
import { Swipe, SwipeItem } from "vant";
export default {
  components: {
    AlumniInfoCard,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      schoolBranchId: this.$route.query.id,
      userId: window.localStorage.getItem("user_id"),
      // userId: "43995379",
      detailData: [],
      isDialActive: false,
      isQrCodeActive: false,
      isOpen: false,
      defaultAvatar,
      btnXuexiao,
      btnDianhua,
      btnRenzheng,
      btnNv,
      btnNan,
      fengeList: [],
      lianxiren: [
        { name: "", tel: "" },
        { name: "", tel: "" },
        { name: "", tel: "" },
        { name: "", tel: "" },
      ],
      phone: "",
    };
  },
  created() {
    this.getSchoolBranchDetail();
  },
  methods: {
    // 获取各地校友详情
    async getSchoolBranchDetail() {
      let base64 = new Base64()
      const result = await this.$http.get("/branch/getBranchInDetail", {
        params: { userId: base64.encode(this.userId), schoolBranchId: this.$route.query.id },
      });
      this.detailData = result.data;
      console.log("校友详情--联络处", this.detailData);
      this.lianxiren[0].name = result.data.contacts1;
      this.lianxiren[0].tel = result.data.phone1;
      this.lianxiren[1].name = result.data.contacts2;
      this.lianxiren[1].tel = result.data.phone2;
      this.lianxiren[2].name = result.data.contacts3;
      this.lianxiren[2].tel = result.data.phone3;
      this.lianxiren[3].name = result.data.contacts4;
      this.lianxiren[3].tel = result.data.phone4;

      if (result.data.content != "") {
        // 使用split方法根据关键字分割字符串
        const content = result.data.content.split("\n");
        // 重新组合分段，包含关键字
        const contentList = [];
        for (let i = 0; i < content.length; i++) {
          contentList.push(content[i]);
        }
        this.fengeList = contentList;
      }
    },

    // 拨打电话
    onHeaderDetailActionClick(action) {
      this.phone = action.tel;
      console.log("拨打电话", this.phone);
      const actionMap = {
        tel: () => {
          this.isDialActive = true;
        },
        qrcode: () => {
          this.isQrCodeActive = true;
        },
      };
      actionMap[action.action]();
    },
    onDialogActionSelect() {
      const link = document.createElement("a");
      link.href = `tel:${this.phone}`;
      link.click();
    },

    onSaveQrCodeBtnClick() {
      console.log("save", this.detailData.qrCode);
      download(this.detailData.qrCode);
    },

    // goDetail() {
    //   this.$emit("go", this.info.aUserId);
    // },
    alumniMembers() {
      console.log("联络处-更多this.detailData.id", this.detailData.id);
      return this.$router.push({
        path: "/AlumniMembers",
        query: { schoolBranchId: this.detailData.id },
      });
    },

    async gotoAlumnusDetail(userId) {
      return this.$router.push({
        path: "/alumniDetailNew",
        query: {
          alumniId: userId,
          // alumniId:43995313
        },
      });
    },

    // 校友加入
    async join() {
      const result = await this.$http({
        url: "/branch/joinBranch",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: {
          userId: this.userId,
          schoolBranchId: this.detailData.id,
        },
      });
      if (result.data.code == 200) {
        this.$toast(result.data.message);
      } else {
        const message =
          result.data.message +
          "\n" +
          "申请加入新组织" +
          "\n" +
          "请联系校友会办公室" +
          "\n" +
          "校友会办公室电话：" +
          "\n" +
          result.data.phone;
        this.$toast(message);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.meetingDetail {
  // position: relative;
  // top: 50px;
  // height: calc(100vh - 20px);
  overflow-y: scroll;
}
.join {
  position: relative;
  width: 75px;
  background: #00706e;
  color: #fff;
  border-radius: 15px;
  padding: 3px 5px 3px 10px;
  margin-top: -35px;
  margin-left: 70vw;
  margin-bottom: 10px;
  text-align: center;
  z-index: 100;
  font-size: 1rem;
}
.Img {
  position: relative;
  width: 94%;
  height: 200px;
  border-radius: 10px;
  left: 3%;
  margin-top: 10px;
  object-fit: cover;
}
.detailTishi {
  position: absolute;
  width: 94%;
  font-size: 0.8rem;
  font-weight: 600;
  position: relative;
  left: 3%;
  margin-top: 20px;
  color: #fa0505;
}
.detailTitle {
  position: absolute;
  width: 94%;
  font-size: 1.1rem;
  font-weight: 600;
  position: relative;
  left: 3%;
  margin-top: 5px;
}
.detailflex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 3%;
  width: 94%;
  margin-top: 10px;
  color: #757575;
  // border: 1px solid #000;
}
.detailflexRow {
  display: flex;
  flex-direction: row;
  margin-top: 5px;
  align-items: center;
  font-size: 0.9rem;
  // justify-content: space-between;
}
.contactsImg {
  margin-left: 5px;
  // width: 15px;
  // height: 15px;
}
.fg {
  width: 100%;
  height: 3px;
  background: #dedede;
  margin-top: 20px;
}
.detailflexbz {
  width: 4px;
  height: 15px;
  background: #00706e;
  margin-right: 5px;
}

.chengyuanList {
  // height: 150px;
  // background: #fff;
  width: 95vw;
  margin-left: 2.5vw;
  margin-top: 10px;
  display: flex;
  flex-direction: row;

  .alumni-card-box {
    position: relative;
    padding: 0 10px;
    border-radius: 10px;
    margin-bottom: 10px;
    border: 1px solid #f3f3f3;
    background-color: #ffffff;
    width: 80%;
    .card-top {
      position: relative;
      padding: 15px 0;
      display: flex;
      align-items: center;
      .open {
        position: absolute;
        bottom: 15px;
        right: 0;
        width: 20px;
        height: 20px;
      }
      .alumni-img-box {
        width: 60px;
        height: 60px;
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          // object-fit: cover;
          background-size: 100% 100%;
          image-rendering: -webkit-optimize-contrast;
        }
        .sex {
          width: 15px;
          height: 15px;
          image-rendering: -webkit-optimize-contrast;
          position: absolute;
          margin-top: -3px;
          margin-left: -15px;
        }
      }
      .alumni-info {
        margin-left: 15px;
        .alumni-name {
          display: flex;
          flex-direction: row;
          align-content: center;
          // border: 1px solid #888;
          color: #333333;
          font-weight: bold;
        }
        .alumni-name-img {
          position: relative;
          width: 13px;
          height: 15px;
          padding-top: 0px;
          image-rendering: -webkit-optimize-contrast;
          margin-left: 20px;
        }
        .alumni-name-div-o {
          font-weight: 500;
          font-size: 12px;
          margin-left: 5px;
        }
        .alumni-name-div-t {
          color: #248381;
          font-weight: 500;
          font-size: 12px;
          margin-left: 5px;
          position: absolute;
          right: 5px;
        }
        .alumni-otherInfo {
          overflow: hidden;
          min-height: 17px;
          color: #757575;
          margin-top: 5px;
        }
      }
    }
    .card-bottom {
      padding: 15px 0;
      border-top: 1px solid #f3f3f3;
      color: #333333;
      .info-detail {
        margin-bottom: 10px;
      }
      span {
        margin-left: 5px;
        color: #333333;
      }
      .go-detail {
        text-align: center;
        font-weight: bold;
        color: #666666;
      }
    }
  }
}

.jieshaobox {
  margin-left: 2.5vw;
  display: flex;
  flex-direction: column;
  width: 90vw;
  border-radius: 10px;
  border: 1px solid #e2e2e2;
  background: #fff;
  font-size: 1rem;
  font-weight: 500;
  line-height: 25px; //行间距
  color: #747474;
  text-indent: 4ch; //首行缩进
  text-align: justify; //两端对齐
  margin-top: 10px;
  padding: 10px;
}

.active-detail__qrcode-image {
  display: block;
  width: 12rem;
  margin: 50px auto 0;
}

.active-detail__qrcode-image-btn {
  display: block;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 30px;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.clearfix-fh:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix-fh {
  *zoom: 1;
}

.alumnusDiv {
  width: 100%;
  padding-top: 5px;
  overflow-x: scroll;
  overflow-y: hidden;
}

.alumnusDiv::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.activeDetailsDiv {
  padding-top: 5px;
  width: 85vw;
  padding-right: 20px;
  overflow-x: scroll;
  overflow-y: hidden;
}

.activeDetailsDiv::-webkit-scrollbar {
  display: none;
}

.activeDetails {
  background-color: white;
  width: 33.3%;
  margin: 5px;
  border-radius: 15px;
  border: 1px solid #e1e1e1;
  white-space: nowrap;
}

.activeDetails-fh {
  width: 80vw;
  margin: 5px;
  float: left;
  border-radius: 15px;
}
</style>




// WEBPACK FOOTER //
// src/components/alumniMeeting/AlumniDetail.vue